<template>
  <div>
    <div class="d-flex flex-row align-center justify-space-between mb-3">
      <div class="text-body-2">{{ taxes.length }} impuesto(s) asignado(s)</div>
      <v-btn
        small
        depressed
        color="accent"
        class="rounded-lg"
        @click="
          $router.push({
            name: 'CreateUserTax',
            id: userId || $route.params.id,
            query: { objectType: 'User' }
          })
        "
      >
        {{ $t("action.add_tax") }}
      </v-btn>
    </div>

    <div class="d-flex flex-column" style="gap: 12px" v-if="taxes.length">
      <template v-for="tax in taxes">
        <tax :tax="tax" @reload="fetchTaxes"></tax>
      </template>
    </div>
  </div>
</template>

<script>
import { UserTaxes } from "@/graphql/queries/directory";

import Tax from "@/components/taxes/Tax";

export default {
  data: () => ({
    taxes: []
  }),

  props: {
    userId: {
      type: [String, Number],
      default: null
    }
  },

  created() {
    this.fetchTaxes();
  },

  methods: {
    fetchTaxes() {
      this.$apollo
        .query({
          query: UserTaxes,
          variables: {
            id: this.userId || this.$route.params.id
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.taxes = res.data.userTaxes;
        });
    }
  },

  components: { Tax }
};
</script>
